// extracted by mini-css-extract-plugin
export var attachment = "_kn-a";
export var emailContainer = "_kn-4";
export var emailContentPaddedContainer = "_kn-b";
export var emailHeader = "_kn-6";
export var emailIframe = "_kn-3";
export var emailInfoIcon = "_kn-9";
export var emailShortenedSummary = "_kn-e";
export var infoDropdown = "_kn-0";
export var infoRowBoundedContent = "_kn-d";
export var internal = "_kn-5";
export var merchant = "_kn-8";
export var messageInputContainer = "_kn-h";
export var normal = "_kn-7";
export var replyCard = "_kn-f";
export var subtleButton = "_kn-1";
export var subtleButtonIconContainer = "_kn-2";
export var toggleViewRepliesButton = "_kn-c";
export var wrappingText = "_kn-g";